import {Key, ReactNode} from 'react';
import Icon, {CalendarOutlined, CarOutlined, HomeOutlined, ToolOutlined, UserOutlined} from '@ant-design/icons';
import {MenuProps} from 'antd';
import {AppRoutePaths} from 'routing/Routes';

export interface SidebarNavigation {
  Icon: typeof Icon;
  title: string;
  url: string;
  children?: Omit<SidebarNavigation, 'Icon'>[];
}

export const sidebarNavigation: SidebarNavigation[] = [
  {url: AppRoutePaths.dashboard.url, title: 'Dashboard', Icon: HomeOutlined},
  {url: AppRoutePaths.garages.url, title: 'Garages', Icon: CarOutlined},
  {
    url: AppRoutePaths.services.url,
    title: 'Services Actions',
    Icon: ToolOutlined,
    children: [
      {url: AppRoutePaths.services.url, title: 'Services'},
      {url: AppRoutePaths.tasks.url, title: 'Tasks'},
    ],
  },
  {url: AppRoutePaths.reservations.url, title: 'Reservations', Icon: CalendarOutlined},
];

export const adminSidebarNavigation: SidebarNavigation[] = [];
adminSidebarNavigation.push(...sidebarNavigation);
adminSidebarNavigation.push({
  url: AppRoutePaths.customers.url,
  title: 'Users',
  Icon: UserOutlined,
  children: [
    {url: AppRoutePaths.customers.url, title: 'Customers'},
    {url: AppRoutePaths.employees.url, title: 'Employees'},
  ],
});

type MenuItem = Required<MenuProps>['items'][number];

export const getNavigationItem = (label: ReactNode, key: Key, icon?: ReactNode, children?: MenuItem[]): MenuItem => ({
  key,
  icon,
  children,
  label,
});
